import { getStatusClass } from "../../common/helper/transaction-status.component.js";
import useNavigation from "../../../hooks/useNavigation.js";

export const usersColumns = (expanded, changeStatus, deleteUser) => {
  const { navigateTo } = useNavigation();

  return [
    // {
    //   name: 'Full Name',
    //   selector: row => row.full_name,
    //   sortable: true,
    //  // style: row => ({ minWidth: '100px' }),
    // },
    // {
    //   name: '',
    //   style: row => ({ display : 'none', 'minWidth':'10px' }),
    // },
    {
      name: "Full Name",
      cell: (row) => (
        <div className="custom-cell-full_name">{row.full_name}</div>
      ),
      sortable: true,
      // style: row => ({ minWidth: '100px' }),
    },

    {
      name: "Email",

      cell: (row) => (
        <div className="custom-cell-email_addressss">
          <p className="mb-0">
            {row.email_address.length > 25
              ? row.email_address.slice(0, 25) + "..."
              : row.email_address}
          </p>
        </div>
      ),
      sortable: true,
      // style: row => ({ minWidth: '100px' }),
    },
    {
      name: "Mobile",

      cell: (row) => (
        <div className="custom-cell-email_addressss">
         <p className="mb-0">{row.mobile_number}</p>
        </div>
      ),
      sortable: true,
      // style: row => ({ minWidth: '100px' }),
    },
    

    // {
    //   name: 'Mobile',
    //   selector: row => row.mobile_number,
    //   sortable: true,
    //   //style: row => ({ minWidth: '50px' }),

    // },
    {
      name: "DOB",
      selector: (row) => row.date_of_birth,
      sortable: true,
      // style: row => ({ minWidth: '50px' }),
    },
    {
      name: "Status",
      selector: (row) => (
        <div
          className={`badge badge-pill ${getStatusClass(
            row.status
          )} font-size-12`}
          style={{
            backgroundColor:
              row.user_id && !!expanded[row.user_id] ? "white" : "",
          }}
        >
          {row.status}
        </div>
      ),
      sortable: true,
      // style: row => ({ minWidth: '50px' }),
    },

    {
      name: "Gender",
      sortable: true,
      button: true,
      selector: (row) => row.gender,
      style: (row) => ({ justifyContent: "flex-start" }),
    },

    {
      name: "Actions",
      button: true,

      cell: (row) => (
        <>
          <a
            className={`fview tooltip ${
              row.status === "Rejected" ? "disable" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => navigateTo("view", "view-user", row.user_id)}
          >
            <i
              className={`fa ${
                row.status === "Rejected" ? "fa-eye disable" : "fa-eye"
              }`}
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">View</span>
          </a>
          <a
            className={`flock tooltip ${
              row.status === "Initiated" || row.status === "Rejected"
                ? "disable"
                : ""
            }`}
            onClick={() => changeStatus(row)}
            style={{ cursor: "pointer" }}
          >
            <i
              className={`fa ${
                row.status === "Initiated" || row.status === "Rejected"
                  ? "fa-lock disable"
                  : row.status === "Suspended"
                  ? "fa-unlock"
                  : "fa-lock"
              }`}
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">Lock</span>
          </a>
          {row.status !== "Initiated" && (
            <a
              className={`fedit tooltip ${
                row.status === "Rejected" || row.status === "Suspended"
                  ? "disable"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={() => navigateTo("edit", "edit-user", row.user_id)}
            >
              <i
                className={`fa ${
                  row.status === "Rejected" || row.status === "Suspended"
                    ? "fa-edit disable"
                    : "fa-edit"
                }`}
                style={{
                  color:
                    row.user_id && !!expanded[row.user_id] ? "white" : "black",
                }}
              />
              <span className="tooltiptext">Edit</span>
            </a>
          )}

          <a
            style={{ cursor: "pointer" }}
            onClick={() => deleteUser(row)}
            className={`ftrash tooltip ${
              row.status === "Initiated" || row.status === "Rejected"
                ? "disable"
                : ""
            }`}
            href="#"
          >
            <i
              className={`fa ${
                row.status === "Initiated" || row.status === "Rejected"
                  ? "fa-trash disable"
                  : "fa-trash"
              }`}
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">Delete</span>
          </a>
          <a
            className="fell tooltip"
            href="#"
            style={{ paddingRight: "25px", cursor: "pointer" }}
          >
            <i
              className="fa fa-ellipsis-v"
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
              aria-hidden="true"
            />
            <span className="tooltiptext">More</span>
          </a>
        </>
      ),
    },
  ];
};
